import React from 'react';
import {
    DropdownButton,
    Image,
} from '@saddlebackchurch/react-cm-ui';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import { connect } from 'react-redux';
import { i18n } from '../../global/constants.js';
import UserAccessStore from '../../global/userAccessStore.js';
import { USER_PERMISSIONS } from '../../global/userPermissionConstants.js';
import { RELEASE_NOTES_OPTION_ID } from './constants';
import { OnUserMenuChange } from './models';

type PropTypes = {
    isCmsPreviewEnabled?: boolean;
    onUserMenuChange: OnUserMenuChange;
    userAccess: UserAccessStore;
    userFullName?: string | null;
};

const mapStateToProps = (state) => {
    const {
        bootstrap: {
            securityContext: {
                userAccess,
                userIdentity,
            },
        },
        myAccount: {
            preferences: {
                isCmsPreviewEnabled,
            },
        },
    } = state;

    return {
        isCmsPreviewEnabled,
        userAccess,
        userFullName: userIdentity.getFullName(),
    };
};

const useStyles = makeStyles(({
    palette,
}) => ({
    root: {
        textAlign: 'right',
        '& .image-avatar-user': {
            '& .icon-use-path': {
                fill: `${palette.grey[400]} !important`,
            },
        },
        '& .icon-caret': {
            display: 'none',
        },
    },
}));

export function UserMenu({
    isCmsPreviewEnabled = false,
    onUserMenuChange,
    userAccess,
    userFullName = null,
}: PropTypes) {
    const classes = useStyles();

    const onUserOptionClick = (event, id) => {
        onUserMenuChange({ id });
    };

    const hasBrowseInDraftMode = userAccess.hasPermission(
        USER_PERMISSIONS.browseInDraftMode,
    );

    return (
        <div
            className={classes.root}
        >
            <DropdownButton
                className="user-dropdown"
                designVersion={2}
                iconType={false}
                id="user-dropdown"
                label={(
                    <div className="user-menu-avatar_container">
                        <span>
                            <Image
                                name={userFullName}
                                size={44}
                                style={{ borderRadius: '50%' }}
                                type="person"
                            />
                        </span>
                    </div>
                )}
                optionsTheme="light"
                variant="text"
            >
                <DropdownButton.Option
                    id="help"
                    onClick={onUserOptionClick}
                >
                    {i18n('Help')}
                </DropdownButton.Option>

                <DropdownButton.Option
                    id="notificationPreferences"
                    onClick={onUserOptionClick}
                >
                    {i18n('Notification Preferences')}
                </DropdownButton.Option>

                <DropdownButton.Option
                    id="previewFeature"
                    onClick={onUserOptionClick}
                >
                    {i18n('Preview Feature')}
                </DropdownButton.Option>

                <DropdownButton.Option
                    id="preferences"
                    onClick={onUserOptionClick}
                >
                    {i18n('Preferences')}
                </DropdownButton.Option>

                <DropdownButton.Option
                    id="changePassword"
                    onClick={onUserOptionClick}
                >
                    {i18n('Change Password')}
                </DropdownButton.Option>

                {hasBrowseInDraftMode && isCmsPreviewEnabled ? (
                    <DropdownButton.Option
                        id={RELEASE_NOTES_OPTION_ID}
                        onClick={onUserOptionClick}
                    >
                        {i18n('Release Notes')}
                    </DropdownButton.Option>
                ) : null}

                <DropdownButton.Option
                    id="logOut"
                    onClick={onUserOptionClick}
                >
                    {i18n('Log Out')}
                </DropdownButton.Option>
            </DropdownButton>
        </div>
    );
}

export default connect(mapStateToProps)(UserMenu);
